<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="router-fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
  export default{
    name: 'App',
    data() {
      return {
        transtionName: 'slide-right'
      }
    },
    mounted() {

    },
    watch: {
      '$route'(to, from) {

      }
    }
  }
</script>

<style>
#app {
  font-family: "Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5d3;
  height: 100%;
  width: 100%;
}
.router-fade-enter-active, .router-fade-leave-active {
  transition: opacity .4s;
}
.router-fade-enter, .router-fade-leave-active {
  opacity: 0;
}
</style>
